module.exports = __webpack_public_path__ + "img/alert.df744c9b.svg";